export const Role = {
  Admin: 'Admin',
  Opretter: 'Opretter',
  Jura: 'Jura',
  HR: 'HR',
  Løn: 'Løn',
  IT: 'IT',
}
